<template>
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="el-card pd20 search">
      <div class="search-box">
        商品状态：
        <el-select class="search-child" v-model="status" style="margin-right: 20px;">
          <el-option
            v-for="(item,index) in status_list"
            :key="index"
            :label="item.name"
            :value="item.id"
          >{{item.name}}</el-option>
        </el-select>商品类型：
        <el-select class="search-child input" v-model="type" style="margin: 0 20px;">
          <el-option
            v-for="(item,index) in type_list"
            :key="index"
            :label="item.name"
            :value="item.id"
          >{{item.name}}</el-option>
        </el-select>
        <el-button type="primary" class="btn" size="small" @click="pullData">查询</el-button>
      </div>
    </div>
    <div class="main">
      <div class="search-box"></div>
      <!-- list -->
      <div class="list-box">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="100" label="序号"></el-table-column>
          <el-table-column prop="id" label="产品ID"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">{{scope.row.type == 1?'单个商品':'套餐商品'}}</template>
          </el-table-column>
          <el-table-column prop="category" label="所属分类"></el-table-column>
          <el-table-column  label="原价（元）">
            <template slot-scope="scope">
              {{scope.row.price/100}}
            </template>
          </el-table-column>
          <el-table-column  label="优惠价格（元）">
            <template slot-scope="scope">
              {{scope.row.discount_price/100}}
            </template>
          </el-table-column>
          <el-table-column  label="内部价格（元）">
            <template slot-scope="scope">
              {{scope.row.wholesale_price/100}}
            </template>
          </el-table-column>
          <el-table-column  label="高报师二阶价格（元）">
            <template slot-scope="scope">
              {{scope.row.gaobao_pro_price/100}}
            </template>
          </el-table-column>
          <el-table-column  label="学习力指导师价格（元）">
            <template slot-scope="scope">
              {{scope.row.xuexi_price/100}}
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">{{scope.row.status == 1?'上架':'下架'}}</template>
          </el-table-column>
           <el-table-column label="备注">
            <template slot-scope="scope">{{scope.row.remark}}</template>
          </el-table-column>
          <el-table-column label="操作" width="350">
            <template slot-scope="scope">
              <el-button  size="mini" icon="el-icon-link" 
                v-clipboard:copy="appLink(scope.row.id,scope.row.pay_config)"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"></el-button>
              <el-button type="primary" size="mini" @click="addOrUpdateHandle(scope.row.id)">编辑</el-button>
              <el-button
                type="warning"
                size="mini"
                @click="failureHandle(scope.$index, scope.row)"
              >{{scope.row.status == 1?'下架':'上架'}}</el-button>
              <el-button type="danger" size="mini" @click="deleteHandle(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 添加按钮 -->
      <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus"  @click="addOrUpdateHandle()" circle></el-button>
      <!-- 分页 -->
      <el-pagination
        class="pages"
        :page-sizes="[25, 50, 75, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pages.size"
        :current-page="pages.page"
        background
        layout="sizes,prev, pager, next"
        :total="pages.count"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import {
  productList,
  changeProductStatus,
  deleteProduct
} from "@/api/measurement";
import { upload_image } from "@/api/operating";
import { isMain } from "@u/tools";

export default {
  data() {
    return {
      list: [],
      pages: {},
      status: 1,
      type: 0,
      formLabelWidth: "100px",
      status_list: [
        {
          id: 1,
          name: "上架"
        },
        {
          id: -1,
          name: "下架"
        }
      ],
      type_list: [
        {
          id: 0,
          name: "全部"
        },
        {
          id: 1,
          name: "单个商品"
        },
        {
          id: 2,
          name: "套餐商品"
        }
      ]
    }
  },

  methods: {
    // 地址
    appLink(id,pay_config){
      if(pay_config){
        return `https://open.xjy.cn/${isMain()?'main':'test'}/ms_package_goods?id=${id}&authorizer_appid=${pay_config.app_id}`
      }else{
        return `https://open.xjy.cn/${isMain()?'main':'test'}/ms_package_goods?id=${id}`
      }
      
    },
    onCopy: function (e) {
      this.$message.success('复制成功，直接粘贴即可！');
    },
    onError: function (e) {
      this.$message.error('复制失败，请重试！');
    },
    /*
     *@param: id 商品id
     *@return: 
     *@Description: 添加or修改
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-09 11:02:33
    */
    addOrUpdateHandle(id){
        let obj = {};
        if(id){
            obj['id'] = id;
        }
        
        this.$router.push({
            path:'/main/product_save',
            query:obj
        });
    },
    // 上架/下架
    failureHandle(index, row) {
      this.$confirm(`确认要${row.status == 1 ? "下架" : "上架"}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          changeProductStatus({
            id: row.id,
            status: row.status == 1 ? -1 : 1
          }).then(data => {
            if (data.error > 0) {
              this.$message(data.msg);
              return false;
            }
            this.$notify({
              title: "成功",
              type: "success"
            });
            this.pullData();
          });
        })
        .catch();
    },
    // 删除
    deleteHandle(index, row) {
      this.$confirm("确定要删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          deleteProduct({
            id: row.id
          }).then(data => {
            if (data.error > 0) {
              this.$message(data.msg);
              return false;
            }
            this.$notify({
              title: "成功",
              message: "已删除",
              type: "success"
            });
            this.pullData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 调整每页显示条数
    handleSizeChange(val) {
      this.pages.size = val;
      this.pullData();
    },
    // 触发分页
    handleCurrentChange(val) {
      this.pages.page = val;
      this.pullData();
    },
    // 初始化获取数据
    pullData() {
      this.$showLoading();
      let obj = {
        page: this.pages ? this.pages.page : null, //页码，默认1
        size: this.pages ? this.pages.size : null //每页数量，默认25
      };
      obj["status"] = this.status;
      obj["type"] = this.type;
      productList(obj)
        .then(data => {
          this.list = data.list;
          this.pages = data.pager;
          this.$hideLoading();
        })
        .catch(err => {
          this.$hideLoading();
        });
    }
  },
  created() {
    this.pullData();
  }
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
}

.addBtn {
  position: absolute;
  left: 0;
  bottom: 0;
}

.pages {
  text-align: right;
  margin-top: 30px;
}


.up-image {
  margin: 20px auto auto;
  width: 187.5px;
  text-align: center;
  border-radius: 8px;
  .error {
    border-radius: 8px;
    background-color: rgba($color: #eeeeee, $alpha: 0.5);
  }
}

.el-radio {
  color: #fff;
}

img.banner {
  width: 100%;
}
</style>
<style lang="scss">
.search {
  margin-bottom: 20px;
  .search-box {
    display: flex;
    align-items: center;
    label {
      font-size: 16px;
      color: #606266;
    }
    .on {
      margin: 0 80px;
    }
    .el-input {
      width: 300px;
    }
  }
}
</style>